import axios, { AxiosResponse } from 'axios';
import { parseJwt } from '../../../misc/Helpers';
import { Environment } from '../../../environment';
import { IFormPartnerData } from '../../../types/types';


// Criando a instância do Axios
const instance = axios.create({
  baseURL: Environment.URL_BASE,
});

// Interceptor de requisição para verificar a expiração do token
instance.interceptors.request.use(
    function (config) {
      const authHeader = config.headers.Authorization;
      if (typeof authHeader === 'string' && authHeader.startsWith('Bearer ')) {
        const token = authHeader.split(' ')[1];
        const data = parseJwt(token);
        if (Date.now() > data.exp * 1000) {
          window.location.href = '/login';
        }
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  

// Função para criar a autenticação Bearer
function bearerAuth(user: { accessToken: string }): string {
  return `Bearer ${user.accessToken}`;
}

// Funções do serviço
export const ParceirosServiceAPI = {
  create,
  signup,
  getById,
  getPartners,
  getOrders,
  getPartnerMe,
  updateById,
  deleteById,
  deletePartner,
  authenticate,
};

function authenticate(username: string, password: string) {
  return instance.post('/auth/authenticate', { username, password }, {
    headers: { 'Content-type': 'application/json' },
  });
}

function signup(user: IFormPartnerData) {
  return instance.post('/auth/signup', user, {
    headers: { 'Content-type': 'application/json' },
  });
}

function create(user: { accessToken: string }, dadosValidados: IFormPartnerData) {
  console.log(dadosValidados);
  return instance.post('/customer/create', dadosValidados, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': bearerAuth(user),
    },
  });
}

function getPartners(user: { accessToken: string }) {
  const url = '/customer/getAll';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getById(user: { accessToken: string }, id: string): Promise<AxiosResponse<IFormPartnerData>> {
    console.log(id);
  const url = `/customer/getById/${id}`;
  return instance.get<IFormPartnerData>(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function deleteById(user: { accessToken: string }, id: string): Promise<AxiosResponse<{ id: string }>> {
  const url = `/customer/deleteById`;
  return instance.post<{ id: string }>(
    url,
    { id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}

function updateById(user: { accessToken: string }, id: string,  dados: IFormPartnerData): Promise<AxiosResponse<IFormPartnerData>> {
  const url = `/customer/updateById`;
  
  return instance.post<IFormPartnerData>(
    url,
    { ...dados, id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}
/*
function updateById = async (id: number, dados: IFormPartnerData): Promise<void | Error> => {
  try {
    await instance.put(`/customer/updateById${id}`, dados);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
}; */

function deletePartner(user: { accessToken: string }, username: string) {
  return instance.delete(`/api/users/${username}`, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getOrders(user: { accessToken: string }, text?: string) {
  const url = text ? `/api/orders?text=${text}` : '/api/orders';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getPartnerMe(user: { accessToken: string }) {
  return instance.get('/api/users/me', {
    headers: { 'Authorization': bearerAuth(user) },
  });
}
